
import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";

export const getRoleLookup = createAsyncThunk('/thunk/get-role-list', async () => {
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/utils/app/v1/get-role-list`,{page:1})
        console.log("role-lookup",response)
        return response
      
    } 
    catch (error) {
        throw error
    }});